import { signal } from 'services/SignalsService'

export default class PaytableModel {
  constructor() {
    this._pages = []
    this._id = 0
    this.createSignal()
  }

  createSignal() {
    signal.on('PAGE:SET', (id) => {
      this.setID(id)
    })
    signal.on('BUTTON:PrevAutoPage', this.makeHandler(-1))
    signal.on('BUTTON:NextAutoPage', this.makeHandler(1))
  }

  makeHandler(delta) {
    const self = this
    return function () {
      self.setID(self._id + delta)
    }
  }

  addID(id){
    this._pages.push(id)
  }

  getList() {
    return this._pages
  }

  setValue(value) {
    this.setID(this._pages.findIndex((bet) => bet == value))
  }

  setID(value) {
    this._id = value < 0 ? 0 : value > this.getMaxID() ? this.getMaxID() : value
    signal.dispatch('PAYTABLE:PAGE', this.getValue())
  }

  getID() {
    return this._id
  }

  getMaxID() {
    return this._pages.length - 1
  }

  getValue() {
    return this._pages[this._id]
  }

  getMinValue() {
    return this._pages[0]
  }

}
